module.exports = __webpack_public_path__ + "static/img_4368-aa3d45d2fce766006fa0e1c80b5da854.webp";